module.exports = __webpack_public_path__ + "img/faq-dashboard-status.8272cd42.jpg";